/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * store how far a video has been watched by a user
 */
export interface VideoProgress {
  watchedSeconds: number;
  totalSeconds: number;
}
